import {
    SCREEN_CHANGE,
    JUMP_SYSTEM,
    JUMP_SYSTEM_START,
    JUMP_SYSTEM_FAILED,
    SET_JUMP_ERROR,
    SET_ACCESS_NOTICE,
    LOGOUT_USER,
    EXPIRE_SESSION
  } from '../actions/types';

  const INITIAL_STATE = {
    screen: 'login',
    previousSystem: {},
    currentSystem: {},
    serverUrl: '/JSON/', // Default to relative URL
    isJumping: false, // Track when a jump is in progress
    targetSystemName: '', // Destination server name during a jump (for the overlay)
    jumpError: '', // Error message from failed jump (shown in AlertModal)
    accessNotice: '' // Access changed while viewing (AuthActions.refreshCloudAccess; shown in AlertModal)
  };

  export default function navigationReducer(state = INITIAL_STATE, action) {
    switch ( action.type ) {
      case SCREEN_CHANGE:
        return {
          ...state,
          screen: action.payload
        }
      case JUMP_SYSTEM_START:
        // Jump started - show loading state. Capture destination name so the
        // live grid overlay can render "Switching server: <name>..."
        return {
          ...state,
          isJumping: true,
          targetSystemName: (action.payload && action.payload.targetName) || ''
        }
      case JUMP_SYSTEM:
        // Jump completed successfully — clear target name (overlay also hides).
        return {
          ...state,
          isJumping: false,
          targetSystemName: '',
          previousSystem: state.currentSystem, // Save previous before jumping
          currentSystem: action.payload.server,
          serverUrl: action.payload.serverUrl
        }
      case JUMP_SYSTEM_FAILED:
        // Jump failed - restore previous state and clear target name.
        return {
          ...state,
          isJumping: false,
          targetSystemName: ''
        }
      case SET_ACCESS_NOTICE:
        return {
          ...state,
          accessNotice: action.payload || ''
        };
      case SET_JUMP_ERROR:
        return {
          ...state,
          jumpError: action.payload || ''
        }
      // The access notice names the previous account's devices, and this slice is persisted: it never
      // outlives the session (review L5, #86bc6dkfa).
      case LOGOUT_USER:
        return {
          ...state,
          screen: 'login',
          previousSystem: {},
          currentSystem: {},
          serverUrl: '/JSON/', // Reset to default
          isJumping: false,
          accessNotice: ''
        }
      case EXPIRE_SESSION:
        return {
          ...state,
          screen: 'login',
          previousSystem: {},
          currentSystem: {},
          serverUrl: '/JSON/', // Reset to default
          isJumping: false,
          accessNotice: ''
        }
      default:
        return state;
    };
  };